import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import NavbarBottom from './NavbarBottom';
import no_image_available from '../images/no_image_available.jpg';


const Gallery = () => {

    const [galeryList, SetGaleryList] = useState([]);

    const urlImg = `${process.env.REACT_APP_BASEURL}/galeri/`;

    const modalRef = useRef(null);

    const [isOpen, setIsOpen] = useState(false);
    const [imageView, setImageView] = useState(null);

    const openModal = () => setIsOpen(true);
    const closeModal = () => setIsOpen(false);

    const modalImage = (e) => {
        openModal();

        setImageView(e);
    };

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_ENDPOINT}/image_galery`)
            .then((res) => {
                return res.json();
            })
            .then((datas) => {
                //console.log(datas);
                SetGaleryList(datas.data);
            });
    }, []);

    return (
        <>
            <div class="max-w-full px-0 py-0 sm:px-6 lg:px-0 lg:py-0 mx-auto bg-[#ffffff]">
                <section class="text-gray-600 body-font pb-20">
                    <div class="container px-5 py-5 mx-auto">
                        <div class="flex flex-col text-center w-full mb-20">
                            <h1 class="sm:text-3xl text-2xl font-medium title-font mb-4 text-gray-900">Gallery Image</h1>
                            <p class="lg:w-2/3 mx-auto leading-relaxed text-base">JDIH Kota Magelang.</p>
                        </div>
                        <div class="flex flex-wrap -m-4">
                            {galeryList.map((data, index) => (
                                <div class="lg:w-1/3 sm:w-1/2 p-4" key={index}>
                                    <div class="flex relative">
                                        {data?.images != '' ?
                                            <img src={urlImg + '' + data.file} alt="Image" class="absolute inset-0 w-full h-[190px] object-cover object-center rounded-xl" />
                                            :
                                            <img src={no_image_available} alt="" />
                                        }
                                        <div class="px-8 py-10 relative z-10 w-full h-[190px] border-4 border-gray-200 bg-white opacity-0 hover:opacity-100 rounded-xl">
                                            <p class="leading-relaxed" onClick={() => modalImage(data.file)}>
                                                {data.name}
                                            </p>
                                            
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    {isOpen && (
                        <div className="fullscreen-modal-overlay">
                            <div className="fullscreen-modal-content">
                                {imageView != null ? 
                                    <img src={urlImg + '' + imageView} />
                                    :
                                    ''
                                }
                               
                                <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                    <button type="button" onClick={closeModal} class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs ring-1 ring-gray-300 ring-inset hover:bg-gray-50 sm:mt-0 sm:w-auto">Close</button>
                                </div>
                            </div>
                        </div>
                    )}
                </section>
            </div>
        </>
    );
};

export default Gallery;
